import { IChampionFilters } from "~/types/champions"
import { ITokenInfo } from "~/types/global"
import { axiosInstance } from "~/utils/axios"

export async function getChampions(
  tokenInfo: ITokenInfo,
  filters: IChampionFilters,
  pagination: { from: number; size: number },
  linkedTenantId?: number
) {
  let url = `tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/champions`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: { filters, pagination }
  })
}

export async function removeChampion(
  tokenInfo: ITokenInfo,
  championId: string,
  linkedTenantId?: number
) {
  let url = `/tenants/${tokenInfo.tenant_id}/users/${tokenInfo.user_id}/champions/${championId}`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "DELETE",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function getChampionAccounts(
  tokenInfo: ITokenInfo,
  linkedTenantId?: number
) {
  let url = `/tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/champions-accounts`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "GET",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    }
  })
}

export async function addChampions(
  tokenInfo: ITokenInfo,
  urls: string[],
  linkedTenantId?: number
) {
  let url = `tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/champions`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "PUT",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data: { data: [...urls] }
  })
}

export async function getChampionsTrackingMessageTemplates(
  tokenInfo: ITokenInfo,
  data: Record<
    string,
    string | number | Record<string, string | number | number[]>
  >,
  linkedTenantId?: number
) {
  let url = `tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/people_tracking/email-template`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data
  })
}

export async function refineChampionsTrackingMessageTemplate(
  tokenInfo: ITokenInfo,
  data: { current_text: string; user_prompt: string },
  linkedTenantId?: number
) {
  let url = `tenants/${tokenInfo?.tenant_id}/users/${tokenInfo?.user_id}/people_tracking/email-template/refine`
  if (linkedTenantId) {
    url += `?linked_tenant_id=${linkedTenantId}`
  }
  return await axiosInstance({
    method: "POST",
    url,
    headers: {
      Authorization: `Bearer ${tokenInfo?.token}`
    },
    data
  })
}
